exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright © 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt\n * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n */.modal-header--bemerkung{padding:10px 58px}.modal-header--bemerkung span{font-size:16px;line-height:25px;letter-spacing:1px;font-weight:700}.modal-header--bemerkung label{padding-top:30px}.modal-body--bemerkung{padding:0 58px}.modal-footer--bemerkung{text-align:center;padding:30px}@media(min-width:1025px){.bemerkung-modal-window .modal-dialog{width:60%;height:700px;left:50%;top:50%;transform:translate(-50%,-50%)!important;margin:0}.bemerkung-modal-window button.close{margin-right:-42px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/dialog/bemerkungDialog.scss
// module id = 851e
// module chunks = 0